import {
  About,
  Careers,
  Contacts,
  Dashboard,
  ErrorPage,
  Services,
} from "../pages";
import { ApplicationsEdit, ApplicationsList } from "../elements/applications";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { CareersCreate, CareersEdit, CareersList } from "../elements/careers";
import {
  ServicesCreate,
  ServicesEdit,
  ServicesList,
} from "../elements/services";

import { AboutList } from "../elements/about/AboutList";
import { AnimatePresence } from "framer-motion";
import { ContactList } from "../elements/contact";
import { ProtectedRoutes } from "./ProtectedRoutes";

// 1. Extract the routes into their own component so we can use the useLocation hook
const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    // 2. Added mode="wait" so exit animations finish BEFORE entry animations start
    <AnimatePresence mode="wait">
      {/* 3. Attach location and key so Framer Motion knows when the route changes */}
      <Routes location={location} key={location.pathname}>
        {/* Removed the deprecated 'exact' prop */}
        <Route path="/" element={<ProtectedRoutes />}>
          <Route index element={<Dashboard />} />

          {/* Organization Routes */}
          <Route path="organization" element={<About />}>
            <Route index element={<AboutList />} />
          </Route>

          {/* Services Routes */}
          <Route path="services" element={<Services />}>
            <Route index element={<ServicesList />} />
            <Route path="create" element={<ServicesCreate />} />
            <Route path="edit/:id/:title" element={<ServicesEdit />} />
          </Route>

          {/* Careers Routes */}
          <Route path="careers" element={<Careers />}>
            <Route index element={<CareersList />} />
            <Route path="create" element={<CareersCreate />} />
            <Route path="edit/:id" element={<CareersEdit />} />
            <Route path="applications">
              <Route index element={<ApplicationsList />} />
              <Route path="edit/:id" element={<ApplicationsEdit />} />
            </Route>
          </Route>

          {/* Messages / Contacts Routes */}
          <Route path="messages" element={<Contacts />}>
            <Route index element={<ContactList />} />
          </Route>
        </Route>

        {/* 404 Catch-All */}
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </AnimatePresence>
  );
};

// Main AppRoutes Component
const AppRoutes = () => {
  return (
    <BrowserRouter>
      <AnimatedRoutes />
    </BrowserRouter>
  );
};

export default AppRoutes;
